const PENDING_SIGNUP_KEY = 'ox_pending_signup';

/**
 * Tracks an in-progress signup across the post-login phone-verification step so
 * the `sign_up` analytics event fires only for a genuine new signup (and not for
 * a returning user who verifies their phone later). Backed by sessionStorage so
 * the flag naturally clears when the tab closes.
 */
export const setPendingSignup = (userId: string): void => {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(PENDING_SIGNUP_KEY, userId);
  } catch {
    /* ignore storage failures */
  }
};

export const getPendingSignup = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    return sessionStorage.getItem(PENDING_SIGNUP_KEY);
  } catch {
    return null;
  }
};

export const clearPendingSignup = (): void => {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(PENDING_SIGNUP_KEY);
  } catch {
    /* ignore storage failures */
  }
};
